import { useEffect, useState } from "react";
import HeroStep from "./HeroStep";
import HeroGreetings from "./HeroGreetings";
import HeroDetails from "./HeroDetails";
import { Form } from "antd";
import HeroTheme from "shared/themes/HeroTheme";
import { LanguageChange } from "shared/components";
import HeroSignup from "./HeroSignup";
import HeroVerification from "./HeroVerification";
import HeroPortal from "./HeroPortal";
import HeroGoodbye from "./HeroGoodbye";
import "./Hero.scss";
import { autenticado } from "shared/helpers/auth-functions";

export enum HeroSteps {
  Hero = "strm-hero",
  Details = "strm-hero-details",
  SignUp = "strm-hero-sign-up",
  Verification = "strm-hero-verification",
  Greetings = "strm-hero-greetings",
  Portal = "strm-hero-portal",
  Goodbye = "strm-hero-goodbye",
}

const StrmHero: React.FC = () => {
  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(HeroSteps.Hero);

  useEffect(() => {
    if (autenticado()) setCurrentStep(HeroSteps.Greetings);
  }, []);

  return (
    <HeroTheme>
      <div className="strm-hero">
        <div style={{ position: "absolute", right: 0 }}>
          <LanguageChange.SelectLanguageChange
            placement="bottomRight"
            dropdownStyle={{ zIndex: 999999, position: "fixed" }}
            width={60}
          />
        </div>
        <Form form={form} layout="vertical">
          {currentStep === HeroSteps.Hero && (
            <HeroStep setCurrentStep={setCurrentStep} />
          )}

          {currentStep === HeroSteps.Details && (
            <HeroDetails setCurrentStep={setCurrentStep} form={form} />
          )}

          {currentStep === HeroSteps.Greetings && (
            <HeroGreetings setCurrentStep={setCurrentStep} />
          )}

          {currentStep === HeroSteps.SignUp && (
            <HeroSignup setCurrentStep={setCurrentStep} />
          )}

          {currentStep === HeroSteps.Verification && (
            <HeroVerification setCurrentStep={setCurrentStep} />
          )}

          {currentStep === HeroSteps.Portal && <HeroPortal />}

          {currentStep === HeroSteps.Goodbye && <HeroGoodbye />}
        </Form>
      </div>
    </HeroTheme>
  );
};

export default StrmHero;
